import { Button, Layout } from "antd";
import React, { useEffect, useState } from "react";
import styled from 'styled-components';
import { useHistory, useParams } from "react-router-dom";
import dayjs from "dayjs";
import { fetchWaitlistById, removeFromWaitlist } from "../../services/WaitListService";
import { notify } from "../../utils/notification";

const { Content } = Layout;

const TimeContainer = styled.div`
  width: 7rem;
  height: 7rem;
  border-radius: 50%;
  margin-bottom: 3rem;
  background-color: #C32340;
  font-size: 1.5rem;
`;

function greeting(name) {
  const currentHour = new Date().getHours();
  if (currentHour >= 5 && currentHour < 12) {
    return `Good morning ${name}!`;
  } else if (currentHour >= 12 && currentHour < 18) {
    return `Good afternoon ${name}`;
  } else {
    return `Good evening ${name}`;
  }
}

const POLL_INTERVAL = 50000;

const WaitingDetails = () => {
  const params = useParams();
  const history = useHistory();
  const [waitingDetails, setWaitingDetails] = useState(null);

  const fetchWaitlistDetails = async () => {
    const data = await fetchWaitlistById(params.id, params.restaurantCode);
    if (!data?.est_wait_time_min) {
      setTimeout(() => {
        fetchWaitlistDetails();
      }, POLL_INTERVAL);
    }
    setWaitingDetails(data);
  }

  useEffect(() => {
    fetchWaitlistDetails();
  }, []);

  const cancelWaitlist = async () => {
    await removeFromWaitlist(params.id, params.restaurantCode);
    notify({ type: 'success', message: 'Cancelled successfully' });
    history.push(`/restaurant/${params.restaurantCode}/waitlist`);
  };
  
  return (
    <Layout className="u-page-layout">
      <Content className="w-full">
        {waitingDetails !== null
          ? <h2 className="text-center">{greeting(waitingDetails.name)}</h2>
          : <h3 className="theme-red text-left">Thank you for joining the waitlist.</h3>
        }
        <div className="text-center p-2 bg-white mb-1" mb-1>
          <h4 className="mb-1">Your estimated wait time</h4>
          <TimeContainer className="d-flex items-center text-white justify-center m-auto">{waitingDetails?.est_wait_time_min || '?'}</TimeContainer>
          <h4 className="mb-1">Your estimated wait time</h4>
          <h2 className="text-theme text-base mb-1">{waitingDetails?.est_wait_time_min ? `${dayjs().add(waitingDetails?.est_wait_time_min, 'minutes')} - ${dayjs().add(waitingDetails?.est_wait_time_min + 15, 'minutes')}` : '-'}</h2>
        </div>
        {!waitingDetails?.est_wait_time_min ? <h5 className="mb-1 text-left">
          Note: As soon as we get your estimated seating time, we’ll update this page.
          </h5> : null}
        <Button type="primary" ghost size="large" block className="mb-1" onClick={cancelWaitlist}>
          Cancel
        </Button>
      </Content>
    </Layout>
  );
};

export default WaitingDetails;
